import React, { ReactNode } from "react";

type ShowProps<T extends boolean> = {
    when: T;
    children: T extends true ? ReactNode : never;
    otherwise?: ReactNode;
}

function Show<T extends boolean>({ when, otherwise, children }: ShowProps<T>) {
    return when ? <>{children}</> : <>{otherwise}</>;
}

export default Show;